<div class="container-fluid">
  <!-- Seção de Seleção de Auditoria -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-md-8">
              <label class="form-label fw-bold">
                <i class="fas fa-search"></i>
                SELECIONAR AUDITORIA:
              </label>
              <select class="form-select form-select-lg" 
                      [(ngModel)]="auditoriaSelecionada" 
                      (change)="onAuditoriaChange()">
                <option [value]="null">Selecione uma auditoria...</option>
                <option *ngFor="let auditoria of auditorias" 
                        [value]="auditoria.id">
                  {{ auditoria.nome }}
                </option>
              </select>
            </div>
            <div class="col-md-4" *ngIf="getAuditoriaSelecionada()">
              <div class="auditoria-info">
                <div class="row">
                  <div class="col-6">
                    <small class="text-muted">Status:</small>
                    <div>
                      <span class="status-indicator" 
                            [ngClass]="getStatusAuditoriaClass(getAuditoriaSelecionada()?.status || '')">
                        {{ getStatusAuditoriaLabel(getAuditoriaSelecionada()?.status || '') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-6">
                    <small class="text-muted">Período:</small>
                    <div class="fw-bold">
                      {{ getAuditoriaSelecionada()?.dataInicio | date:'dd/MM/yyyy' }} - 
                      {{ getAuditoriaSelecionada()?.dataFim | date:'dd/MM/yyyy' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Header com título e botões de ação -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center">
        <h2 class="dashboard-title">
          <i class="fas fa-shield-alt"></i>
          {{ getAuditoriaSelecionada()?.nome || 'Selecione uma auditoria' }}
        </h2>
        <div class="action-buttons">
          <button type="button" class="btn btn-success me-2" (click)="visualizarDetalhes(null)">
            <i class="fas fa-file-alt"></i>
            Detalhes
          </button>
          <button type="button" class="btn btn-success" (click)="imprimirRelatorio()">
            <i class="fas fa-print"></i>
            Imprimir
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Seção de Gráficos -->
  <div class="row mb-4">
    <!-- Gráfico Status das Ações -->
    <div class="col-md-6">
      <div class="card chart-card">
        <div class="card-header">
          <h5 class="card-title mb-0">
            <i class="fas fa-chart-pie"></i>
            STATUS DAS AÇÕES
          </h5>
        </div>
        <div class="card-body">
          <div class="chart-container">
            <div class="donut-chart">
              <div class="donut-chart-bg">
                <div class="donut-segment nao-concluida" 
                     [style.transform]="'rotate(' + (getPercentualNaoConcluida() * 3.6) + 'deg)'">
                </div>
                <div class="donut-segment concluida" 
                     [style.transform]="'rotate(' + (getPercentualConcluida() * 3.6) + 'deg)'">
                </div>
                <div class="donut-center">
                  <span class="donut-number">{{ statusAcoes.total }}</span>
                  <span class="donut-label">AÇÕES</span>
                </div>
              </div>
            </div>
            <div class="chart-legend">
              <div class="legend-item">
                <span class="legend-color nao-concluida"></span>
                <span class="legend-text">Não-concluída</span>
              </div>
              <div class="legend-item">
                <span class="legend-color concluida"></span>
                <span class="legend-text">Concluída</span>
              </div>
              <div class="legend-item">
                <span class="legend-color a-vencer"></span>
                <span class="legend-text">A vencer</span>
              </div>
              <div class="legend-item">
                <span class="legend-color atrasada"></span>
                <span class="legend-text">Atrasada</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Gráfico Execução das Atividades -->
    <div class="col-md-6">
      <div class="card chart-card">
        <div class="card-header">
          <h5 class="card-title mb-0">
            <i class="fas fa-chart-pie"></i>
            EXECUÇÃO DAS ATIVIDADES (TOTAL: {{ execucaoAtividades.total }})
          </h5>
        </div>
        <div class="card-body">
          <div class="chart-container">
            <div class="pie-chart">
              <div class="pie-chart-bg">
                <div class="pie-segment a-fazer" 
                     [style.transform]="'rotate(' + (getPercentualAFazer() * 3.6) + 'deg)'">
                </div>
                <div class="pie-segment em-andamento" 
                     [style.transform]="'rotate(' + (getPercentualEmAndamento() * 3.6) + 'deg)'">
                </div>
                <div class="pie-segment concluido" 
                     [style.transform]="'rotate(' + (getPercentualConcluido() * 3.6) + 'deg)'">
                </div>
              </div>
            </div>
            <div class="chart-legend">
              <div class="legend-item">
                <span class="legend-color a-fazer"></span>
                <span class="legend-text">A fazer</span>
              </div>
              <div class="legend-item">
                <span class="legend-color passado"></span>
                <span class="legend-text">Passado</span>
              </div>
              <div class="legend-item">
                <span class="legend-color em-andamento"></span>
                <span class="legend-text">Em andamento</span>
              </div>
              <div class="legend-item">
                <span class="legend-color impedimento"></span>
                <span class="legend-text">Impedimento</span>
              </div>
              <div class="legend-item">
                <span class="legend-color concluido"></span>
                <span class="legend-text">Concluído</span>
              </div>
              <div class="legend-item">
                <span class="legend-color cancelado"></span>
                <span class="legend-text">Cancelado</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Seção Lista de Ações -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h5 class="card-title mb-0">
            <i class="fas fa-list"></i>
            LISTA DE AÇÕES
          </h5>
        </div>
        <div class="card-body">
          <!-- Filtros e Controles -->
          <div class="filters-section mb-3">
            <div class="row align-items-center">
              <div class="col-md-3">
                <label class="form-label">FILTRAR POR STATUS:</label>
                <select class="form-select" [(ngModel)]="filtroStatus" (change)="onFiltroStatusChange()">
                  <option value="todos">Listar todos (Total)</option>
                  <option value="a_fazer">A fazer</option>
                  <option value="em_andamento">Em andamento</option>
                  <option value="concluido">Concluído</option>
                  <option value="impedimento">Impedimento</option>
                  <option value="cancelado">Cancelado</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">FILTRAR POR ESTADO:</label>
                <select class="form-select" [(ngModel)]="filtroEstado" (change)="onFiltroEstadoChange()">
                  <option value="todos">Listar todos (Total)</option>
                  <option value="Não-concluída">Não-concluída</option>
                  <option value="Concluída">Concluída</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Resultados por página:</label>
                <select class="form-select" [(ngModel)]="resultadosPorPagina" (change)="onResultadosPorPaginaChange()">
                  <option value="5">5 resultados por página</option>
                  <option value="10">10 resultados por página</option>
                  <option value="25">25 resultados por página</option>
                  <option value="50">50 resultados por página</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Procurar:</label>
                <input type="text" class="form-control" 
                       [(ngModel)]="termoBusca" 
                       (input)="onBuscaChange()"
                       placeholder="Digite para buscar...">
              </div>
            </div>
          </div>

          <!-- Tabela de Ações -->
          <div class="table-responsive">
            <table class="table table-striped table-hover">
                             <thead>
                 <tr>
                   <th style="width: 50px;"></th>
                   <th>O que?</th>
                   <th>Responsável</th>
                   <th>Data início</th>
                   <th>Data término</th>
                   <th>Status</th>
                   <th>Estado</th>
                 </tr>
               </thead>
                               <tbody>
                  <ng-container *ngFor="let acao of acoesPaginadas">
                    <!-- Linha principal -->
                    <tr>
                      <td>
                        <button type="button" 
                                class="btn btn-sm btn-link expand-btn" 
                                (click)="toggleLinha(acao.id)"
                                [title]="isLinhaExpandida(acao.id) ? 'Colapsar detalhes' : 'Expandir detalhes'">
                          <i [class]="getIconeExpandir(acao.id)"></i>
                        </button>
                      </td>
                      <td>
                        <strong>{{ acao.descricao }}</strong>
                      </td>
                      <td>{{ acao.responsavel }}</td>
                      <td>{{ acao.dataInicio | date:'dd/MM/yyyy' }}</td>
                      <td>{{ acao.dataTermino | date:'dd/MM/yyyy' }}</td>
                      <td>
                        <span class="status-indicator" [ngClass]="getStatusClass(acao.status)">
                          <i [class]="getStatusIcon(acao.status)"></i>
                          {{ getStatusLabel(acao.status) }}
                        </span>
                      </td>
                      <td>{{ acao.estado }}</td>
                    </tr>
                                         <!-- Linha expandida com detalhes (logo abaixo da linha principal) -->
                     <tr class="detail-row" 
                         [class.show]="isLinhaExpandida(acao.id)">
                       <td colspan="7">
                         <div class="detail-content">
                           <div class="row">
                             <div class="col-md-6">
                               <h6>Detalhes da Ação</h6>
                               <p><strong>Descrição:</strong> {{ acao.descricao }}</p>
                               <p><strong>Responsável:</strong> {{ acao.responsavel }}</p>
                             </div>
                             <div class="col-md-6">
                               <h6>Datas</h6>
                               <p><strong>Início:</strong> {{ acao.dataInicio | date:'dd/MM/yyyy' }}</p>
                               <p><strong>Término:</strong> {{ acao.dataTermino | date:'dd/MM/yyyy' }}</p>
                               <p><strong>Status:</strong> {{ getStatusLabel(acao.status) }}</p>
                             </div>
                           </div>
                           
                           <!-- Nova tabela de detalhes -->
                           <div class="row mt-4">
                             <div class="col-12">
                               <h6>Itens da Ação</h6>
                               <div class="table-responsive">
                                 <table class="table table-sm table-hover detail-table">
                                   <thead>
                                     <tr>
                                       <th>Nome</th>
                                       <th>Tipo</th>
                                       <th>Descrição</th>
                                       <th>Ação</th>
                                     </tr>
                                   </thead>
                                   <tbody>
                                     <tr *ngFor="let detalhe of getDetalhesAcao(acao.id)">
                                       <td>
                                         <strong>{{ detalhe.nome }}</strong>
                                       </td>
                                       <td>
                                         <span class="tipo-indicator" [ngClass]="getTipoClass(detalhe.tipo)">
                                           <i [class]="getTipoIcon(detalhe.tipo)"></i>
                                           {{ getTipoLabel(detalhe.tipo) }}
                                         </span>
                                       </td>
                                       <td>{{ detalhe.descricao }}</td>
                                       <td>
                                         <button type="button" 
                                                 class="btn btn-sm btn-primary" 
                                                 (click)="responderDetalhe(detalhe)"
                                                 title="Responder">
                                           <i class="fas fa-reply"></i>
                                           Responder
                                         </button>
                                       </td>
                                     </tr>
                                   </tbody>
                                 </table>
                               </div>
                             </div>
                           </div>
                         </div>
                       </td>
                     </tr>
                  </ng-container>
                </tbody>
            </table>
          </div>

          <!-- Paginação -->
          <div class="pagination-section">
            <div class="row align-items-center">
              <div class="col-md-6">
                <p class="mb-0">
                  Mostrando de {{ (paginaAtual - 1) * resultadosPorPagina + 1 }} 
                  até {{ Math.min(paginaAtual * resultadosPorPagina, acoesFiltradas.length) }} 
                  de {{ acoesFiltradas.length }} registros
                </p>
              </div>
              <div class="col-md-6">
                <nav aria-label="Navegação de páginas">
                  <ul class="pagination justify-content-end mb-0">
                    <li class="page-item" [class.disabled]="paginaAtual === 1">
                      <a class="page-link" href="#" (click)="paginaAnterior(); $event.preventDefault()">
                        Anterior
                      </a>
                    </li>
                    <li class="page-item" *ngFor="let pagina of getPaginas()" 
                        [class.active]="pagina === paginaAtual">
                      <a class="page-link" href="#" 
                         (click)="irParaPagina(pagina); $event.preventDefault()">
                        {{ pagina }}
                      </a>
                    </li>
                    <li class="page-item" [class.disabled]="paginaAtual === getTotalPaginas()">
                      <a class="page-link" href="#" (click)="proximaPagina(); $event.preventDefault()">
                        Próximo
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
